<template>
  <v-row>
    <v-col class="shrink"> <BackBtn /></v-col>
    <v-spacer></v-spacer>
    <v-col class="text-right">
      <h1 class="display-1 font-weight-light">{{ title }}</h1>
      <small v-if="subtitle">{{ subtitle }}</small>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    title: {
      default: '',
    },
    subtitle: {
      default: '',
    },
  },
};
</script>

<style scoped>
</style>
